import * as React from 'react';
import { ComplexValue } from '../../common/types';
import { RadioSymbol, Validation, ValidationProps } from '../..';
import { v1 as uuid } from 'uuid';
import { OptionColor } from 'ui/common/select/option/option-color';
import styles from './select-single-radio-button.scss';

export interface SelectSingleRadioButtonProps {
  componentId: string;
  option: ComplexValue<number>;
  onChange: any;
  isSelected: boolean;
  readOnly?: boolean;
  validation?: ValidationProps;
}

export class SelectSingleRadioButton extends React.Component<SelectSingleRadioButtonProps, any> {
  constructor(props: SelectSingleRadioButtonProps) {
    super(props);
    this.state = {
      componentUuid: uuid()
    };
  }

  public onChange = () => {
    this.props.onChange(this.props.option);
  };

  public render() {
    const { componentId, validation, option } = this.props;
    const { componentUuid } = this.state;
    const radioButtonStyle = !!validation ? styles.hasDanger : '';

    return (
      <>
        <div className="form-check form-check-inline">
          <input id={`input-${componentId}-${componentUuid}`} type="radio"
            className="form-check-input visuallyhidden"
            value={this.props.option.value}
            checked={this.props.isSelected}
            onChange={this.onChange}
            disabled={this.props.readOnly} />
          <label htmlFor={`input-${componentId}-${componentUuid}`} className={`form-check-label media ${radioButtonStyle}`}>
            <RadioSymbol />
            {(!!option?.backgroundColor || option?.backgroundColor === 0) ? <OptionColor color={option.backgroundColor} /> : null}
            {this.props.option.description}
          </label>
        </div>
        {!!validation && <Validation {...validation} />}
      </>
    );
  }
}
